export const types = {
  SET_ADMIN_USERS: "SET_ADMIN_USERS",
  CREATE_ADMIN_USER: "CREATE_ADMIN_USER",
  UPDATE_ADMIN_USER: "UPDATE_ADMIN_USER",
  DELETE_ADMIN_USER: "DELETE_ADMIN_USER",
};
